import ProductGrid from '@nespresso/catalog-components-react/containers/ProductGrid';
import type { ComponentChildren } from 'preact';
import type { Product } from '@/domain/Product';
import ProductTagsSection from '../sections/ProductTagsSection/ProductTagsSection.tsx';
import ProductImageSection from '../sections/ProductImageSection/ProductImageSection.tsx';
import ProductNameSection from '../sections/ProductNameSection/ProductNameSection.tsx';
import ProductHeadlineSection from '../sections/ProductHeadlineSection/ProductHeadlineSection.tsx';
import VertuoOversizedCapsuleCompatibilitySection from '../sections/VertuoOversizedCapsuleCompatibilitySection/VertuoOversizedCapsuleCompatibilitySection.tsx';
import ProductPurchaseSection from '../sections/ProductPurchaseSection/ProductPurchaseSection.tsx';
import styles from './MachineProductCard.module.scss';
import CardBase from '../CardBase/CardBase.tsx';
import TechnologyLabelSection from '../sections/TechnologyLabelSection/TechnologyLabelSection.tsx';
import FavoriteButton from '../sections/FavoriteButton/FavoriteButton.tsx';
import useMediaQuery from '@/widgets/hooks/useMediaQuery.tsx';

export type MachineProductCardProps = {
  product: Product;
  onClick?: (event: MouseEvent) => void;
  lazyLoadProductImage?: boolean;
  onPurchaseSectionImpression: () => void;
  itemListName: string;
  children?: ComponentChildren;
  class?: string;
};

// TODO: implement the MachineProductCard, currently it's a duplication of the AccessoryProductCard
export default function MachineProductCard({
  product,
  lazyLoadProductImage,
  onClick,
  onPurchaseSectionImpression,
  itemListName,
  children,
  class: className
}: MachineProductCardProps) {
  const { isMobile } = useMediaQuery();

  return (
    <CardBase
      className={className}
      onClick={onClick}
      extensions={children}
      longSku={product.id}
      shortSku={product.nessoft.legacyId}
      productType={product.type}
    >
      {isMobile && (
        <FavoriteButton product={product} itemListName={itemListName} />
      )}

      <ProductGrid.GridItemImageSection className={styles.wrapper}>
        {!isMobile && (
          <FavoriteButton product={product} itemListName={itemListName} />
        )}

        <ProductTagsSection product={product} />
        <ProductImageSection
          product={product}
          width={112}
          lazyLoadProductImage={lazyLoadProductImage}
        />
      </ProductGrid.GridItemImageSection>

      <ProductGrid.GridItemContent className={styles.content}>
        <ProductNameSection product={product} />
        <ProductHeadlineSection product={product} class={styles.headline} />
        <VertuoOversizedCapsuleCompatibilitySection product={product} />
        <TechnologyLabelSection product={product} />
      </ProductGrid.GridItemContent>

      <ProductGrid.GridItemFooter>
        <ProductPurchaseSection
          product={product}
          onImpression={onPurchaseSectionImpression}
        />
      </ProductGrid.GridItemFooter>
    </CardBase>
  );
}
